import React from 'react'
import { Create } from 'react-admin'

import ChatbotQuestionsForm from './form'

export const ChatbotQuestionsCreate = (props) => (
  <Create {...props}>
    <ChatbotQuestionsForm isEdit={false} {...props} />
  </Create>
)

export default ChatbotQuestionsCreate
